import { type FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SystemValidationTextField, type ValidationTextFieldProps } from "../../UIToolkit/Inputs/SystemValidationTextField";
import { HOLIDAY_NAME_MAX_LENGTH } from "./holidayApi";
import { holidayNameLooksLikeDate } from "./holidayFormat";

type Props = {
	value: string;
	onChange: (name: string) => void;
	placeholder?: string;
	autoFocus?: boolean;
	dataTestId: string;
};

/** A holiday's name: at most as long as the server takes, and flagged as soon as it starts like a date. */
export const HolidayNameField: FC<Props> = ({ value, onChange, placeholder, autoFocus, dataTestId }) => {
	const { t } = useTranslation();
	const validation = useMemo<ValidationTextFieldProps>(
		() => ({
			validationCallback: (name) => !holidayNameLooksLikeDate(name),
			helperText: { invalid: t("holidays.dialog.nameLooksLikeDate") },
			performValidation: "always",
			showValidWhenValid: "never",
		}),
		[t],
	);
	return (
		<SystemValidationTextField
			label={t("name")}
			value={value}
			onChange={(event) => onChange(event.target.value)}
			validation={validation}
			placeholder={placeholder}
			reserveHeightForHelperText={false}
			injectedProps={{ slotProps: { htmlInput: { maxLength: HOLIDAY_NAME_MAX_LENGTH } } }}
			fullWidth
			autoFocus={autoFocus}
			dataTestId={dataTestId}
		/>
	);
};
